import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import {
  getmaxAnswerableQuestions,
  getAllAnswersBySection,
  getAllMarkedQuestions,
  getQuizDetails,
  getUnansweredQuestions
} from '@selectors/quizTaking';
import { getNtaSectionCounts } from '../ntaSectionCounts';

const useNtaSectionSummaries = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const answersBySection = useSelectorWithShallowEqual(getAllAnswersBySection);
  const maxAnswerableQuestionBySection = useSelectorWithShallowEqual(
    getmaxAnswerableQuestions
  );
  const markedQuestionsBySection = useSelectorWithShallowEqual(
    getAllMarkedQuestions
  );
  const unansweredQuestionsBySection = useSelectorWithShallowEqual(
    getUnansweredQuestions
  );

  return useMemo(() => {
    const sections = quizDetails?.sections ?? [];

    return sections.map((section) => {
      const counts = getNtaSectionCounts(section.uid, {
        answersBySection,
        maxAnswerableQuestionBySection,
        markedQuestionsBySection,
        unansweredQuestionsBySection
      });
      const totalQuestions =
        maxAnswerableQuestionBySection?.[section.uid] ??
        section.questions_count ??
        0;

      return {
        sectionUID: section.uid,
        sectionName: section.title || quizDetails.title,
        totalQuestions,
        ...counts
      };
    });
  }, [
    answersBySection,
    markedQuestionsBySection,
    maxAnswerableQuestionBySection,
    quizDetails?.sections,
    quizDetails.title,
    unansweredQuestionsBySection
  ]);
};

export default useNtaSectionSummaries;
